<template>
  <div class="small-char-preview">
    <span class="char-avatar-wrap">
      <img
          :src="avatarLink"
          alt="Character Avatar"
          class="char-avatar-img"
          @error="onAvatarError"
      />
      <FlowSignMark v-if="signed" :size="12"/>
    </span>
    <div class="char-details">
      <span class="char-name">{{ char.name }}</span>
      <span v-if="char.npc" class="char-npc">(NPC)</span>
    </div>
  </div>
</template>

<script>
import {CharacterInfoGameService} from "@/services/characterInfoService.js";
import {fallbackOnError} from "@/utils/imageFallback";
import {avatarPlaceholderUrl} from "@/utils/avatarPlaceholder";
import FlowSignMark from '@/components/CharacterToken/FlowSignMark.vue';

export default {
  name: 'SmallCharPreview',
  components: {
    FlowSignMark,
  },
  props: {
    char: Object,
    gmMode: Boolean,
  },
  async created() {
    this.info = await CharacterInfoGameService.getCharacterInfo(this.char.id, this.gmMode);
    this.avatarLink = await CharacterInfoGameService.getAvatarUrl(this.char.id, this.gmMode) || this.placeholder;
    if (this.info) {
      this.char.name = this.info.name;
      this.char.npc = this.info.npc;
      this.signed = Boolean(this.info.game_master_mode);
    }
  },
  computed: {},
  data() {
    return {
      /* Was `https://via.placeholder.com/24` — a third-party host that no longer
         answers, so the "placeholder" was itself a broken image. The log line
         only ever knows a character id, so this is `other.png`, the server's own
         avatar default. */
      placeholder: avatarPlaceholderUrl(),
      avatarLink: null,
      signed: false,
    };
  },
  methods: {
    onAvatarError(event) {
      fallbackOnError(event, this.placeholder);
    },
  },
};
</script>

<style scoped>
.char-avatar-wrap {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.char-avatar-img {
  height: 2em;
  width: 2em;
  border-radius: 50%;
  object-fit: cover;
}

.small-char-preview {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.1rem 0.5rem;
  border-radius: 4px;
}

.char-avatar img {
  width: 2em;
  height: 2em;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--gm-border-dim);
}

.char-details {
  display: flex;
  flex-direction: column;
}

.char-name {
  font-weight: bold;
  color: var(--gm-text);
  font-size: 0.5rem;
}

.char-npc {
  font-size: 0.5rem;
  color: var(--gm-text-muted);
}
</style>
